import 'twin.macro'

import ArrowDownIcon from 'assets/icons/ArrowDownIcon'
import ArrowLeftIcon from 'assets/icons/ArrowLeftIcon'
import ChevronDownSmallIcon from 'assets/icons/ChevronDownSmallIcon'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useState } from 'react'
import tw from 'twin.macro'

import SubTitle from '../sub-title/sub-title'
import Title from '../title/title'
import { Trans } from 'react-i18next'

function DropDownBlock({ data }: { data: { a: string; q: string } }) {
  const [open, setOpen] = useState<boolean>(false)
  const { isMobile } = useDeviceInfo()
  return (
    <button tw='bg-faq rounded-s32 p-6 sm:p-10 text-left flex flex-col gap-5' onClick={() => setOpen(!open)}>
      <div tw='flex w-full justify-between items-center gap-2'>
        <Title variant='bold' twStyle={open ? tw`text-green sm:text-s24 text-s18` : tw` sm:text-s24 text-s18`}>
          {data.q}
        </Title>
        <div>
          {isMobile ? (
            <ChevronDownSmallIcon css={[open ? tw`text-green rotate-180` : tw`text-secondary`]} />
          ) : (
            <ArrowDownIcon css={[open ? tw`text-green rotate-180` : tw`text-secondary`]} />
          )}
        </div>
      </div>
      {open && <SubTitle twStyle={tw`sm:text-s18 text-s16`}><Trans components={{br: <br />}}>{data.a}</Trans></SubTitle>}
    </button>
  )
}

export default DropDownBlock
